<template>
    <monitor-layout 
        v-bind:monitor_filter="monitor_filter" 
        v-bind:title="title" 
        v-on:updateFilters="_updateFilters" 
        v-on:updateFilterPreview="_updateFilterPreview"
        v-on:updateDates="_updateDates">
        <template v-slot:default="slotProps">
             <b-loading :is-full-page="isFullPage" :active.sync="showLoader"></b-loading>
            <div> 
                <div class="chart-row">
                    <LineChartBox v-if="partialConversionsIncluded" :subLabels="{type: ['final', 'partial'], measurement: ['count', 'percent']}" subLabelType="twoSublabels" chartTitle="Conversions" :chartData="conversionsChart"> </LineChartBox>
                    <LineChartBox v-else :subLabels="{measurement: ['count', 'percent']}" subLabelType="singleLabel" chartTitle="Conversions" :chartData="filteredConversionsChart"> </LineChartBox> 

                    <!--<LineChartBox :subLabels="{type: ['final', 'partial'], measurement: ['count', 'percent']}" subLabelType="twoSublabels" chartTitle="Conversions" :chartData="conversionsChart"> </LineChartBox>-->
                    <LineChartBox :subLabels="{measurement: ['count', 'value']}" subLabelType="singleLabel" chartTitle="Transaction Count & Value" :chartData="transactionVolumeChart"> </LineChartBox>   
                </div>
                <div class="chart-row">
                    <DoughnutChartBox chartTitle="Transactions by Payment Method" :chartData="paymentMethodsChart"> </DoughnutChartBox>
                    <VerticalBarChartBox chartTitle="Transaction Funnel" :chartData="funnelChart"> </VerticalBarChartBox>  
                </div>       
                <ViewDetails v-if = "_dataExists(userDetails)":columnOrder= "columnOrder" :userDetails="userDetails"/></ViewDetails>
            </div>
        </template>
    </monitor-layout>
</template>
<script>
import MonitorLayout from './common/layout/MonitorLayout';
import monitorMixins from 'SrcRoot/mixins/monitor_mixins';
import { isEmpty, isEqual, cloneDeep } from "lodash";
import ViewDetails from './common/partials/ViewDetails';
import DoughnutChartBox from './common/chartbox/DoughnutChartBox';
import VerticalBarChartBox from './common/chartbox/VerticalBarChartBox';
import LineChartBox from './common/chartbox/LineChartBox';
import moment from 'moment';
import EventBus from "@/utils/event-bus";

export default {
    name: "Transactions",
    mixins: [
        monitorMixins
    ],
    components: {
        'monitor-layout': MonitorLayout,
        ViewDetails,
        DoughnutChartBox,
        VerticalBarChartBox,
        LineChartBox
    },
    computed: {
        component_name() {
            return 'Transactions: ';
        },
    },
    data() {
        return {
            funnel:{},
            paymentMethods:{},
            funnelChart:{},
            paymentMethodsChart:{},
        }  
    },
    mounted() {
        this.$nextTick(() => { 
            this._setup();
            
        }); 
    },
    methods: {
        initLocalData() {
            this.funnel={};
            this.paymentMethods={};
            this.transactionVolume={};
            this.conversions={};
            //this.filteredConversionsChart={};
        },
        updateFunnelChart() {
            this.$set(this, 'funnelChart', {});
            const labels = ['All', 'Product', 'Payment', 'Success', 'Failure'];
            this.$set(this.funnelChart, 'labels', labels);
            let allCount=0, productCount=0, paymentCount= 0, successCount=0, failureCount=0;
            for (const date in this.funnel) {
                allCount = allCount + this.funnel[date]['all'];
                productCount =productCount + this.funnel[date]['productSelection'];
                paymentCount = paymentCount + this.funnel[date]['paymentMethod'];
                successCount =successCount + this.funnel[date]['transactionSuccess'];
                failureCount = failureCount + this.funnel[date]['transactionFailure'];
            }
            const counts = [allCount, productCount, paymentCount, successCount, failureCount ];
            const totalCount = counts.reduce((total, count) => total + count, 0);
            const percents = totalCount === 0
                ? counts.map(_ => '0.00') // If total count is zero, set all percentages to '0.00'
                : counts.map(count => Number(((count / totalCount) * 100).toFixed(2)));

            this.$set(this.funnelChart, 'datasets', [{category: 'count', data: counts},{category: 'percent',data: percents}])
        },

        getPaymentMethodLabels() {
            let labels = [...this.creditCardInCampaign, ...this.walletsInCampaign];
            let formattedLabels = [];
            for (const label of labels) {
                if (label == 'applePay') formattedLabels.push('Apple Pay');
                if (label == 'googlePay') formattedLabels.push('Google Pay');
                if (label == 'paypal') formattedLabels.push('Pay Pal');
                if (label == 'Credit Card') formattedLabels.push('Credit Card');
            }
            return formattedLabels;

        },

        updatePaymentMethodsChart() {
            this.$set(this, 'paymentMethodsChart', {});
            const labels = this.getPaymentMethodLabels();
            this.$set(this.paymentMethodsChart, 'labels', labels);
           
            // Initialize an object to store totals for each label
            const counts = {};

            // Loop through each label and initialize its total to 0
            labels.forEach(label => {
              counts[label] = 0;
            });

            const paymentMethods = this.paymentMethods;
            for (const date in paymentMethods) {
                const dateObject = paymentMethods[date];
                labels.forEach(label => {
                    if (dateObject[label]) {
                      counts[label] += dateObject[label];
                    }
                });
            }
            const countsArray = labels.map(label => counts[label]);
            // Calculate the total sum of counts
            const totalCount = countsArray.reduce((acc, count) => acc + count, 0);
            const percentsArray = countsArray.map(count => parseFloat(((count / totalCount) * 100).toFixed(2)));
            this.$set(this.paymentMethodsChart, 'category', 'count');
            this.$set(this.paymentMethodsChart, 'datasets', [
                {category: 'count',data: countsArray},
                {category: 'percent',data: percentsArray}
            ]);

        },

        initFunnel(date) {
            this.funnel[date] = {}
            this.funnel[date]['all'] = this.visitorsEachDay[date];
            this.funnel[date]['productSelection'] = 0;
            this.funnel[date]['paymentMethod'] = 0;
            this.funnel[date]['transactionSuccess'] = 0;
            this.funnel[date]['transactionFailure'] = 0;  
        },

        updateFunnel(date, type, success) {
            if (isEmpty(this.funnel[date])) this.initFunnel(date);
            if (type == 'processingResult') {
                if (success) this.funnel[date]['transactionSuccess'] +=1;
                else this.funnel[date]['transactionFailure'] +=1;
            } else this.funnel[date][type] += 1;
        },

        updatePaymentMethod(paymentMethod, date) { // paymentMethod is "Pay Pal", Apple Pay etc
            if (this.paymentMethods[date] == undefined) this.paymentMethods[date] = {};
            if (this.paymentMethods[date][paymentMethod] == undefined) this.paymentMethods[date][paymentMethod] = 1;
            else this.paymentMethods[date][paymentMethod] += 1
        },

        updateTransactionsChart() {
            this.initLocalData();
             //this._initVisitorsByDay(); // visitorsEachDay made a computed property
            const filteredVisitors = this._filterVisitors(); 
            for (const visitor of filteredVisitors) { 
                const { 
                    conversion:visit_conversions, // array of objects - since a campaign can have multiple conversion hooks, 
                    transactions,
                    created_at } = visitor;
                const date = moment(created_at).format('YYYY-MM-DD');

                if (!isEmpty(transactions)) {
                   const deDupedTransactions = this._filterDuplicateTransactionData(transactions);
                   for (const transaction of deDupedTransactions) {
                        // type is productSelection, paymentMethod, processingResult, 
                        const {type, productPrice, paymentMethod, success} = transaction;
                        this.updateFunnel(date, type, success); // keep count of visitors in each of the 3 steps of processing 
                    }
                    const paymentMethodTransaction = deDupedTransactions.find(obj => obj.type === 'paymentMethod');
                    const processingResultTransaction = deDupedTransactions.find(obj => obj.type === 'processingResult');
                    if (paymentMethodTransaction) {
                        const {paymentMethod} = paymentMethodTransaction;
                        this.updatePaymentMethod(paymentMethod, date);
                    }
                    if (processingResultTransaction) {
                        const {productPrice, success} = processingResultTransaction;
                        this._updateTransactionVolume(productPrice, success, date);
                    }
                }
               
                this._updateConversions(date, visit_conversions);
            }
     
            this.fillDayRange();
            this.updateFunnelChart();
            this.updatePaymentMethodsChart();
            this._updateTransactionVolumeChart();
            this._updateConversionsChart();
            //this._filterPartialConversion();
        },

        getEmptyPaymentMethodsObject() {
            let paymentMethods = [...this.creditCardInCampaign, ...this.walletsInCampaign];
            // Create an object with payment methods as properties and initialize their values to 0
            return paymentMethods.reduce((acc, method) => {
              acc[method] = 0;
              return acc;
            }, {});
        },

        fillDayRange() {
            const dateRange = this._createDateRange();
            let emptyPaymentMethods = this.getEmptyPaymentMethodsObject();            
            for (const date of dateRange) {
                if (isEmpty(this.funnel[date])) this.funnel[date] = {'all':0, 'productSelection':0, 'paymentMethod':0,'transactionSuccess':0,'transactionFailure':0};
                //{'Pay Pal':0, 'Google Pay':0, 'Apple Pay':0,'Credit Card':0,'transactionFailure':0}
                if (isEmpty(this.paymentMethods[date])) this.paymentMethods[date] = emptyPaymentMethods;
                if (isEmpty(this.transactionVolume[date])) this.transactionVolume[date] = {'count':0, 'value':0}
                if (isEmpty(this.conversions[date])) this.conversions[date] = {'none':0, 'partial':0, 'final':0};
            }
            this.funnel = this._sortInDescendingOrderByDate(this.funnel);
            this.paymentMethods = this._sortInDescendingOrderByDate(this.paymentMethods);
            this.transactionVolume = this._sortInDescendingOrderByDate(this.transactionVolume);
            this.conversions = this._sortInDescendingOrderByDate(this.conversions); //console.log(this.transactionVolume);
        },

        updateChartData() {
            this.updateTransactionsChart();
        },
    },

}
</script>
<style lang="scss" scoped>

@import "SrcRoot/modules/Campaign/components/monitor/scss/monitor.scss";

</style>
